<template>
  <div>
    <portal v-if="targetel && isRaqCta" :name="name" :target-el="'#' + targetel" slim>
      <button
        data-type="booking interest"
        data-name="raq"
        class="button is-subtle cta"
        @click.prevent="[
          toggleModal(tour, tourselecteddate, tourdepartureid, $event),
          dataLayerRAQOpen()
        ]"
        v-text="labels.button"
      />
    </portal>
    <portal v-else-if="targetel && isCallNowCta" :name="name" :target-el="'#' + targetel" slim>
      <button
        data-type="booking interest"
        data-name="raq"
        class="button is-subtle cta"
        @click.prevent="openCallNowModal(computedPhoneNumber)"
      >
        Call Now
      </button>
    </portal>
    <button
      v-if="!targetel && isRaqCta"
      class="button is-subtle is-pulled-right cta"
      @click.prevent="[
        toggleModal(tour, tourselecteddate, tourdepartureid, $event),
        dataLayerRAQOpen()
      ]"
      v-text="labels.button"
    />
    <button
      v-else-if="!targetel && isCallNowCta"
      class="button is-subtle is-pulled-right cta"
      @click.prevent="openCallNowModal(computedPhoneNumber)"
    >
      Call Now
    </button>
  </div>
</template>
<script>
import {
  getComputedPhoneNumber,
  isCallNowCtaVisible,
  isRaqCtaVisible
} from '../../utils/ctaVisibility';
import EventBus from '../../vue-functions/event-bus';

export default {
  props: {
    tour: Object,
    labels: Object,
    tourselecteddate: String,
    tourdepartureid: String,
    name: String,
    targetel: String,
    modalSettings: Object,
    callNowModal: Object
  },
  computed: {
    isRaqCta() {
      return isRaqCtaVisible(this && this.tour, this.modalSettings);
    },
    isCallNowCta() {
      return isCallNowCtaVisible(this && this.tour, this.modalSettings);
    },
    computedPhoneNumber() {
      return getComputedPhoneNumber(this.isCallNowCta, this && this.tour, this.callNowModal);
    }
  },
  methods: {
    toggleModal(tour, tourselecteddate, tourdepartureid, event) {
      EventBus.$emit(
        'TOGGLE_RAQ_MODAL',
        tour,
        tourselecteddate,
        tourdepartureid,
        this.modalSettings
      );
      const target = event.target;
      EventBus.$emit('update-raq-target', target);

      this.$nextTick(() => {
        window.lcw?.refresh?.();
      });
    },
    dataLayerRAQOpen() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'RAQ Button Clicked From Trip' });
    },
    openCallNowModal(phoneNumber) {
      EventBus.$emit('TOGGLE_CALL_NOW_MODAL', { phoneNumber });
    }
  }
};
</script>
